import {createSelector} from '@ngrx/store';

import * as fromStoreItemReducer from './store-item.reducer';
import {AppState} from "../../index";
import {StoreItemEntity} from "./store-item.model";

export const currentState = (state: AppState) => (state[fromStoreItemReducer.storeItemsFeatureKey]);

export const selectAllItems = createSelector(currentState, fromStoreItemReducer.getAllStates);

export const selectStoreItems = (entity: StoreItemEntity) => createSelector(selectAllItems, (states) => {
  return states[entity]
});

export const selectFilterStoreItem = (entity: StoreItemEntity, filtering: object) => createSelector(selectAllItems, (states) => {
  let result: any;
  let filterKeys = Object.keys(filtering);
  result = states[entity].find(item => {
    for (let key of filterKeys) {
      if (item[key] === filtering[key]) {
        return true;
      }
    }
    return false;
  });
  return result;
});
